const Like = ({ color }: any) => {
  return (
    <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M7 22.5H4C3.46957 22.5 2.96086 22.2893 2.58579 21.9142C2.21071 21.5391 2 21.0304 2 20.5V13.5C2 12.9696 2.21071 12.4609 2.58579 12.0858C2.96086 11.7107 3.46957 11.5 4 11.5H7M14 9.5V5.5C14 4.70435 13.6839 3.94129 13.1213 3.37868C12.5587 2.81607 11.7956 2.5 11 2.5L7 11.5V22.5H18.28C18.7623 22.5055 19.2304 22.3364 19.5979 22.024C19.9654 21.7116 20.2077 21.2769 20.28 20.8L21.66 11.8C21.7035 11.5134 21.6842 11.2207 21.6033 10.9423C21.5225 10.6638 21.3821 10.4063 21.1919 10.1875C21.0016 9.96873 20.7661 9.79393 20.5016 9.67522C20.2371 9.5565 19.9499 9.49672 19.66 9.5H14Z'
        stroke={color || '#65676B'}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default Like
